import React from "react";
import { Link } from "react-router-dom";
const getTransactionColumns = () => {
  const getUserName = (user) =>
    [user?.firstName, user?.surname].filter(Boolean).join(" ");

  return [
    {
      title: "S.No",
      dataIndex: "id",
      render: (text, record, index) => index + 1,
      sorter: (a, b) => a.id.length - b.id.length,
      width: "10%",
    },
    {
      title: "Name",
      dataIndex: "user",
      render: (user) => getUserName(user),
      width: "20%",
    },
    {
      title: "Email",
      dataIndex: "user",
      render: (user) => user?.email || "",
      width: "20%",
    },
    {
      title: "TotalAmount",
      dataIndex: "totalAmount",
      width: "15%",
    },
    {
      title: "Duration",
      dataIndex: "duration",
      render: (duration) => `${Math.floor(duration / 60)} min`,
      width: "15%",
    },
    {
      title: "Type",
      dataIndex: "type",
      render: (type) => (type === "mobile" ? "Virtual" : "Physical"),
      width: "15%",
    },
    {
      title: "Start Date",
      dataIndex: "startTime",
      render: (startTime) =>
        startTime ? new Date(startTime).toISOString().split("T")[0] : "",
      width: "15%",
    },
    {
      title: "End Date",
      dataIndex: "endTime",
      render: (endTime) =>
        endTime ? new Date(endTime).toISOString().split("T")[0] : "",
      width: "15%",
    },
    {
      title: "Status",
      dataIndex: "status",
      width: "15%",
    },
    // {
    //   title: "Action",
    //   className: "text-end",
    //   render: (text, record) => (
    //     <div className="dropdown dropdown-action text-end">
    //       <Link
    //         to="#"
    //         className="action-icon dropdown-toggle"
    //         data-bs-toggle="dropdown"
    //         aria-expanded="false"
    //       >
    //         <i className="material-icons">more_vert</i>
    //       </Link>
    //       <div className="dropdown-menu dropdown-menu-right">
    //         <Link className="dropdown-item" to={`/AddLocations/${record.id}`}>
    //           <i className="fa fa-pencil m-r-5" /> Edit
    //         </Link>
    //         <button
    //           className="dropdown-item"
    //           //   onClick={() => deleteFunc(record.id)}
    //         >
    //           <i className="fa fa-trash m-r-5" /> Delete
    //         </button>
    //       </div>
    //     </div>
    //   ),
    //   width: "15%",
    // },
  ];
};

export default getTransactionColumns;
